export const IMAGE_STATUSES = {
  identical: 'IDENTICAL',
  pending: 'PENDING',
  offline: 'OFFLINE',
  duplicate: 'DUPLICATE',
  legitimate: 'LEGITIMATE',
  notPursuable: 'NOT_PURSUABLE',
  nonIdentical: 'NOT_IDENTICAL'
};

export const QC_IMAGE_STATUSES = {
  identical: 'IDENTICAL',
  offline: 'OFFLINE',
  nonIdentical: 'NOT_IDENTICAL'
};

export const SIGHTINGS_COLUMNS = [
  {
    title: '',
    dataIndex: 'imageStatus',
    width: '16%'
  },
  {
    title: '',
    dataIndex: 'images',
    width: '60%'
  },
  {
    title: '',
    dataIndex: 'photographerName',
    width: '25%'
  },
  {
    title: 'Diff.',
    dataIndex: 'difference',
    width: '5%'
  }
];

export const REVIEW_STATUSES = {
  information: 'INFORMATION',
  review: 'REVIEW',
  noComment: 'NO_COMMENT'
};

export const FILTER_OPTIONS = {
  imageStatus: {
    name: 'Image status',
    key: 'status'
  },
  agency: {
    name: 'Agency',
    key: 'agency'
  },
  difference: {
    name: 'Difference',
    key: 'difference'
  },
  ImageID: {
    name: 'Image ID',
    key: 'imageId'
  },
  photographerName: {
    name: 'Photographer',
    key: 'photographerName'
  },
  updatedAt: {
    name: 'Date last modified',
    key: 'lastModifyDateFromHeader'
  },
  createdAt: {
    name: 'Date first found',
    key: 'foundAt'
  }
};
